module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firstNotCompleted":"The first questionnaire has not been submitted.","secondNotCompleted":"The second questionnaire has not been submitted."},"de":{"firstNotCompleted":"Der erste Fragebogen wurde nicht eingereicht.","secondNotCompleted":"Der zweite Fragebogen wurde nicht eingereicht."}}')
  delete Component.options._Ctor
}
